export const firebaseConfig = {
  apiKey: 'AIzaSyAQ-fQut3KHoKJ9BmOgmbLUnAuSEUYHqPY',
  authDomain: 'appreport-5c44c.firebaseapp.com',
  databaseURL: 'https://appreport-5c44c.firebaseio.com',
  projectId: 'appreport-5c44c',
  storageBucket: 'appreport-5c44c.appspot.com',
  messagingSenderId: '321309881821'
}



// WEBPACK FOOTER //
// ./src/configs/index.js